import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-t border-r border-gray-800 dark:border-gray-100 fixed bottom-0 left-0 z-50 px-3 py-2 flex items-center justify-center gap-2 rounded-tr-xl bg-white dark:bg-black" }

import UiThemeToggle from '@/components/ui/UiThemeToggle.vue';
import UiLocaleSwitch from '@/components/ui/UiLocaleSwitch.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'UiQuickSettings',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UiThemeToggle, { size: "sm" }),
    _createVNode(UiLocaleSwitch, { size: "sm" })
  ]))
}
}

})